import { render, staticRenderFns } from "./CampoLectura.vue?vue&type=template&id=578d4d5d&scoped=true&"
import script from "./CampoLectura.vue?vue&type=script&lang=js&"
export * from "./CampoLectura.vue?vue&type=script&lang=js&"
import style0 from "./CampoLectura.vue?vue&type=style&index=0&id=578d4d5d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "578d4d5d",
  null
  
)

export default component.exports